<template>
  <div class="background-with-overlay" :style="containerStyle">
    <!-- 背景图片 -->
    <!-- <div class="background-image" :style="backgroundStyle"></div> -->
    <!-- 定位到背景图片特定位置的图片或HTML内容 -->
    <div class="overlay-content" :style="overlayStyle">
      <!-- 如果是图片模式 -->
      <div
        v-if="!useHtmlContent"
        class="overlay-image"
      ></div>
      <!-- 如果是HTML内容模式 -->
      <div v-else class="overlay-html-content">
        <div class="background-brand-story-card">
          <div class="background-brand-story-label">
            {{ $t("meticulousCare.label") }}
          </div>
          <div class="background-brand-story-title">
            {{ $t("meticulousCare.title") }}
            <img
              :class="{
                'background-brand-story-underline-zh': $i18n.locale === 'zh',
                'background-brand-story-underline-en': $i18n.locale === 'en'
              }"
              class="background-brand-story-underline"
              src="@/assets/images/yellow.png"
              alt="underline"
            />
          </div>
          <div class="background-brand-story-desc">
            {{ $t("meticulousCare.desc") }}
          </div>
          <button class="background-brand-story-btn" @click="handleLearnMore">
            {{ $t("meticulousCare.learnMore") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BackgroundWithOverlay",
  props: {
    // 背景图片
    backgroundImage: {
      type: String,
      required: true,
    },
    // 背景图片样式
    backgroundSize: {
      type: String,
      default: "cover",
    },
    backgroundPosition: {
      type: String,
      default: "center",
    },
    backgroundRepeat: {
      type: String,
      default: "no-repeat",
    },
    // 定位图片
    overlayImage: {
      type: String,
      default: "",
    },
    // 定位图片样式
    overlaySize: {
      type: String,
      default: "cover",
    },
    overlayPosition: {
      type: String,
      default: "center",
    },
    overlayRepeat: {
      type: String,
      default: "no-repeat",
    },
    // 容器样式
    containerHeight: {
      type: String,
      default: "",
    },
    // 定位图片的位置和尺寸
    overlayTop: {
      type: String,
      default: "0",
    },
    overlayLeft: {
      type: String,
      default: "0",
    },
    overlayWidth: {
      type: String,
      default: "auto",
    },
    overlayHeight: {
      type: String,
      default: "auto",
    },
    // 定位图片的样式
    overlayBorderRadius: {
      type: String,
      default: "0",
    },
    overlayBoxShadow: {
      type: String,
      default: "none",
    },
    // 是否启用悬停效果
    enableHover: {
      type: Boolean,
      default: true,
    },
    // 是否使用HTML内容而不是图片
    useHtmlContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerStyle() {
      return {
        height: this.containerHeight,
      };
    },
    backgroundStyle() {
      // 处理require()返回的模块对象
      const bgUrl =
        typeof this.backgroundImage === "string"
          ? this.backgroundImage
          : this.backgroundImage.default || this.backgroundImage;

      return {
        backgroundImage: `url(${bgUrl})`,
        backgroundSize: this.backgroundSize,
        backgroundPosition: this.backgroundPosition,
        backgroundRepeat: this.backgroundRepeat,
      };
    },
    overlayStyle() {
      return {
        top: this.overlayTop,
        left: this.overlayLeft,
        width: this.overlayWidth,
        height: this.overlayHeight,
        borderRadius: this.overlayBorderRadius,
        boxShadow: this.overlayBoxShadow,
      };
    },
    // overlayImageStyle() {
    //   // 处理require()返回的模块对象
    //   const overlayUrl =
    //     typeof this.overlayImage === "string"
    //       ? this.overlayImage
    //       : this.overlayImage.default || this.overlayImage;

    //   return {
    //     // backgroundImage: `url(${overlayUrl})`,
    //     backgroundSize: this.overlaySize,
    //     backgroundPosition: this.overlayPosition,
    //     backgroundRepeat: this.overlayRepeat,
    //   };
    // },
  },
  methods: {
    handleLearnMore() {
      // 处理"了解更多"按钮点击事件
      this.$emit("learn-more-click");
    },
  },
};
</script>

<style scoped>
.background-with-overlay {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* 背景图片容器 */
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 990px;
  z-index: 1;
}

/* 定位到背景图片特定位置的图片容器 */
.overlay-content {
  position: absolute;
  z-index: 2;
  transition: transform 0.3s ease;
}

.overlay-content:hover {
  transform: scale(1.02);
}

.overlay-image {
  width: 100%;
  height: 100%;
}

/* HTML内容样式 */
.overlay-html-content {
  width: 715px;
  height: auto;
  min-height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 40px;
}

.background-brand-story-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  border-radius: 40px;
  padding: 48px 40px;
  max-width: 715px;
  width: 715px; /* 固定宽度 */
  box-sizing: border-box;
  height: auto;
  position: relative;
}

.background-brand-story-label {
  font-family: "Alibaba PuHuiTi";
  font-weight: 500;
  font-size: 18px;
  color: #000000;
  margin-bottom: 16px;
  opacity: 0.87;
}

.background-brand-story-title {
  font-family: "Alibaba PuHuiTi";
  font-weight: 600;
  font-size: 32px;
  line-height: 56px;
  color: #282938;
  margin-bottom: 24px;
  position: relative;
  white-space: pre-line;
  min-height: 112px; /* 最小高度，2行文本 = 56px * 2 */
  height: auto; /* 自动调整高度 */
}

.background-brand-story-underline {
  position: absolute;
  width: 170px; /* 固定宽度：715px(卡片宽度) - 80px(左右内边距) */
  height: 18px;
  border-radius: 10px;
  z-index: 0;
  pointer-events: none;
  user-select: none;
  bottom: 30px; /* 相对于文本底部定位，适应不同语言 */
}

.background-brand-story-underline-zh {
  top: 25%;
  left: 0px;
}

.background-brand-story-underline-en {
  top: 40%;
  left: 0px;
}

.background-brand-story-desc {
  font-family: "Alibaba PuHuiTi";
  font-weight: 400;
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 32px;
  white-space: pre-line;
}

.background-brand-story-btn {
  height: 40px;
  width: 112px;
  background: transparent;
  border: 2px solid #282938;
  color: #282938;
  border-radius: 100px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Alibaba PuHuiTi";
}

.background-brand-story-btn:hover {
  background: #282938;
  color: #fff;
}
</style>
